import { render, staticRenderFns } from "./KamusCat.vue?vue&type=template&id=676b9333&"
import script from "./KamusCat.vue?vue&type=script&lang=js&"
export * from "./KamusCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports